/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Shot_OfficeInputs */

const en_tut_shot_office = /** @type {(inputs: Tut_Shot_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The pixel-art virtual office map: a lobby with three named colleagues, a team room lined with desks, a meeting room, a focus zone, and a lounge; the nearby-chat panel sits on the right.`)
};

const id_tut_shot_office = /** @type {(inputs: Tut_Shot_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peta kantor virtual bergaya pixel: lobi berisi tiga rekan dengan nama di atas kepalanya, ruang tim dengan deretan meja, ruang rapat, zona fokus, dan lounge; panel chat sekitar di sisi kanan.`)
};

/**
* | output |
* | --- |
* | "The pixel-art virtual office map: a lobby with three named colleagues, a team room lined with desks, a meeting room, a focus zone, and a lounge; the nearby-c..." |
*
* @param {Tut_Shot_OfficeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_shot_office = /** @type {((inputs?: Tut_Shot_OfficeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Shot_OfficeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_shot_office(inputs)
	return en_tut_shot_office(inputs)
});